import { Component } from "react";
import PropTypes from "prop-types";

export default class DelayedMount extends Component {
  static propTypes = {
    delay: PropTypes.number.isRequired,
    children: PropTypes.any.isRequired,
  };

  state = {
    shouldMount: false,
  };

  componentDidMount() {
    this.interval = setTimeout(
      () =>
        this.setState({
          shouldMount: true,
        }),
      this.props.delay,
    );
  }

  componentWillUnmount() {
    // if the component unmounts before `this.props.delay`
    clearTimeout(this.interval);
  }

  render() {
    const { children } = this.props;
    const { shouldMount } = this.state;

    return shouldMount ? children : null;
  }
}
